export default __webpack_public_path__ + "static/media/Prisondick.94f187b7.PNG";